import React from "react";
import DefaultImagingSettingTextBox from "./DefaultImagingSettingTextBox";
import { StandardDropLocatorCaptureProperty } from "../../../Model/CaptureProfile";
import "./StandardDropLocator.css";

const MIN_LENGTH_MICRONS = "minLengthMicrons";
const MAX_LENGTH_MICRONS = "maxLengthMicrons";
const WHITE_PIXEL_MIN = "whitePixelMin";
const WHITE_PIXEL_MAX = "whitePixelMax";
const ITERATIONS = "iterations";
const MAX_ASPECT_RATIO = "maxAspectRatio";

interface Props {
  style: any;
  standardDropLocator: StandardDropLocatorCaptureProperty;
  onChange: (standardDropLocator: StandardDropLocatorCaptureProperty) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
}

export default function StandardDropLocatorView({ style, standardDropLocator, onChange, onErrorOccur, onErrorCleared }: Props) {
  const onValueChanged = (name: string, value: number) => {
    onChange({
      ...standardDropLocator,
      [name]: value,
    });
  };
  return (
    <div
      className="standard-dl"
      style={{
        ...style,
      }}
    >
      <DefaultImagingSettingTextBox
        value={standardDropLocator[MIN_LENGTH_MICRONS]}
        onChange={onValueChanged}
        label="Min. Length"
        name={MIN_LENGTH_MICRONS}
        unit="µm"
        style={{
          gridArea: MIN_LENGTH_MICRONS,
        }}
        min={10}
        max={standardDropLocator[MAX_LENGTH_MICRONS] - 1}
        disabled={false}
        isInteger={true}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />
      <DefaultImagingSettingTextBox
        value={standardDropLocator[MAX_LENGTH_MICRONS]}
        onChange={onValueChanged}
        label="Max. Length"
        name={MAX_LENGTH_MICRONS}
        unit="µm"
        style={{
          gridArea: MAX_LENGTH_MICRONS,
        }}
        min={standardDropLocator[MIN_LENGTH_MICRONS] + 1}
        max={1000000}
        disabled={false}
        isInteger={true}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={standardDropLocator[WHITE_PIXEL_MIN]}
        onChange={onValueChanged}
        label="White Pixel Min"
        name={WHITE_PIXEL_MIN}
        unit=""
        style={{
          gridArea: WHITE_PIXEL_MIN,
        }}
        min={0}
        max={ standardDropLocator[WHITE_PIXEL_MAX] - 1}
        disabled={false}
        isInteger={true}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={standardDropLocator[WHITE_PIXEL_MAX]}
        onChange={onValueChanged}
        label="White Pixel Max"
        name={WHITE_PIXEL_MAX}
        unit=""
        style={{
          gridArea: WHITE_PIXEL_MAX,
        }}
        min={standardDropLocator[WHITE_PIXEL_MIN] + 1}
        max={255}
        disabled={false}
        isInteger={true}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={standardDropLocator[ITERATIONS]}
        onChange={onValueChanged}
        label="Open Iterations"
        name={ITERATIONS}
        unit=""
        style={{
          gridArea: ITERATIONS,
        }}
        min={1}
        max={1000000}
        disabled={false}
        isInteger={true}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />

      <DefaultImagingSettingTextBox
        value={standardDropLocator[MAX_ASPECT_RATIO]}
        onChange={onValueChanged}
        label="Max. Aspect Ratio"
        name={MAX_ASPECT_RATIO}
        unit=""
        style={{
          gridArea: MAX_ASPECT_RATIO,
        }}
        min={1}
        max={1000000}
        disabled={false}
        isInteger={false}
        onErrorCleared={onErrorCleared}
        onErrorOccur={onErrorOccur}
      />
    </div>
  );
}
